import React from 'react';
import { Modal } from 'rsuite';

/**
 * we use a Modal wrapper
 * because we cannot lazy import from rsuite like this:
 * const Modal = React.lazy(()=>import('rsuite/Modal'));
 * it will break the app
 *
 * @param {*} props
 */
export default function RsModal(props) {
  const { children, ...otherProps } = props;
  return <Modal {...otherProps}>{children}</Modal>;
}
